import { Component, OnInit } from '@angular/core';
import { environment as ENV } from 'environments/environment';

@Component({
  selector: 'wl-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  demo : any;

  public screenWidth: any;

  public screenHeight: any;
  screenBreak:any=false;
  constructor() {
    switch(ENV.placeHolderSetting.demo) {
      

      default :
      // this.navList = NAVIGATION_SHRK;
      this.demo = ENV.placeHolderSetting.demo;
      break;
    }
   }

  ngOnInit() {

    this.screenWidth = window.innerWidth;

    this.screenHeight = window.innerHeight;
    console.log(this.screenWidth);
    if(this.screenWidth<500){
      this.screenBreak = true;
    }
   }

}
